function formatNotification(props) {
    return {
        Kind: props.kind || 'MESSAGE',
        TempId: props.temp_id || props.TempId,
        Avatar: props.avatar || props.Avatar,
        Message: props.message || props.Message || 'new_message',
        Detail: props.detail || props.Detail || '',
        CreatedAt: props.created_at || props.CreatedAt || new Date(),
        ToUserId: String(props.to_user_id || props.ToUserId),
        UserId: props.user_id || props.UserId,
    };
}

export default formatNotification;
